import { Button, Flex, Text, TextVariant } from '@mprolab/uikit'
import React from 'react'
import styled, { useTheme } from 'styled-components'
import UseAnimations from 'react-useanimations'
import loading from 'react-useanimations/lib/loading'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'

const Wrapper = styled(Flex)`
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 24px;
  margin-top: 48px;
`

interface ActivityLogLoadingProps {
  onDismiss?: () => void
}

const ActivityLogLoading: React.FC<ActivityLogLoadingProps> = observer(({ onDismiss }) => {
  const { t } = useTranslation()
  const { colors } = useTheme()
  return (
    <Wrapper>
      <UseAnimations animation={loading} strokeColor={colors.white} size={40} />
      <Flex flexDirection="column" gap="8px" mb="24px">
        <Text textAlign="center" variant={TextVariant.BODY_BIG_BOLD}>
          {t('rewards.generatingActivityLog')}
        </Text>
        <Text textAlign="center" color={colors.gray6}>
          {t('rewards.thisCanTakeUpFewMinutes')}
        </Text>
      </Flex>
      <Button fullWidth onClick={onDismiss}>
        {t('general.cancel')}
      </Button>
    </Wrapper>
  )
})

export default ActivityLogLoading
